import { render, staticRenderFns } from "./addSaveMoneyOnCard.vue?vue&type=template&id=5a6d2ce0&scoped=true&"
import script from "./addSaveMoneyOnCard.vue?vue&type=script&lang=js&"
export * from "./addSaveMoneyOnCard.vue?vue&type=script&lang=js&"
import style0 from "./addSaveMoneyOnCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addSaveMoneyOnCard.vue?vue&type=style&index=1&id=5a6d2ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6d2ce0",
  null
  
)

component.options.__file = "addSaveMoneyOnCard.vue"
export default component.exports